import React, { useEffect } from "react";
import { connect } from "react-redux";

import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";

function CyberPaySuccess(props) {
  useEffect(function () {
    props.setHistory(props.history);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <p style={{ fontSize: "2em" }}>Processing</p>
    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  setAlertMessage: authAction.setAlertMessage,
  setHistory: historyAction.setHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(CyberPaySuccess);
